export const categories = [
  {
    id: "technology",
    name: "科技",
    slug: "technology",
    description: "前沿科技资讯、人工智能、数字化转型",
    color: "bg-accent-500",
    textColor: "text-accent-700",
    articleCount: 128,
  },
  {
    id: "business",
    name: "商业",
    slug: "business",
    description: "商业洞察、市场趋势、创业故事",
    color: "bg-primary-500",
    textColor: "text-primary-700",
    articleCount: 96,
  },
  {
    id: "lifestyle",
    name: "生活",
    slug: "lifestyle",
    description: "健康生活、美食旅行、家居设计",
    color: "bg-secondary-500",
    textColor: "text-secondary-700",
    articleCount: 84,
  },
  {
    id: "culture",
    name: "文化",
    slug: "culture",
    description: "艺术展览、书籍电影、人文思考",
    color: "bg-accent-500",
    textColor: "text-accent-700",
    articleCount: 72,
  },
  {
    id: "international",
    name: "国际",
    slug: "international",
    description: "全球视野、国际新闻、跨文化交流",
    color: "bg-primary-500",
    textColor: "text-primary-700",
    articleCount: 115,
  },
];

export const articles = [
  {
    id: "1",
    title: "人工智能正在重塑全球工作方式的五大趋势",
    excerpt: "从自动化流程到创意辅助，AI技术正在以前所未有的速度改变我们的工作方式。本文深入分析2025年最值得关注的五大AI趋势。",
    content: `人工智能正在重塑全球工作方式的五大趋势

从自动化流程到创意辅助，AI技术正在以前所未有的速度改变我们的工作方式。本文深入分析2025年最值得关注的五大AI趋势。

一、智能自动化全面渗透

过去两年，RPA（机器人流程自动化）与AI的结合已经从概念验证走向大规模部署。据统计，全球已有超过40%的企业在核心业务流程中引入了智能自动化系统。从财务报表生成到客户服务响应，AI正在接管那些重复性高、规则明确的工作任务。

二、生成式AI成为创意伙伴

ChatGPT、Midjourney等生成式AI工具不再只是新奇玩具，而是成为了设计师、作家、营销人员的日常工作伙伴。调查显示，76%的创意工作者已经在工作中使用AI辅助工具，平均每人每天节省2.3小时。

三、个性化学习系统崛起

教育科技领域正在经历一场革命。基于AI的个性化学习平台能够根据每个学生的学习进度、兴趣偏好和认知特点，动态调整教学内容。这种\"千人千面\"的教育模式正在全球范围内推广。

四、远程协作智能化

随着混合办公模式的普及，AI驱动的协作工具正在解决远程团队的沟通效率问题。实时翻译、智能会议纪要、情绪分析等功能让跨国团队协作变得更加顺畅。

五、决策支持系统进化

企业管理层越来越依赖AI驱动的决策支持系统。这些系统能够整合来自多个数据源的信息，提供预测性分析和情景模拟，帮助领导者在复杂环境中做出更明智的选择。

展望未来，AI技术将继续深化与各行业的融合。对于职场人士来说，适应与AI协作的新模式，培养AI无法替代的人类独有技能，将是保持竞争力的关键。`,
    category: "technology",
    categoryName: "科技",
    author: "张明远",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20an%20Asian%20male%20journalist%20in%20his%20mid-30s%2C%20wearing%20a%20dark%20blazer%2C%20neutral%20studio%20background%2C%20soft%20natural%20lighting%2C%20confident%20expression%2C%20high%20quality%20portrait&width=200&height=200&seq=author-1&orientation=squarish",
    date: "2026-06-28",
    readTime: "8分钟",
    image: "https://readdy.ai/api/search-image?query=Abstract%20futuristic%20technology%20concept%20with%20glowing%20neural%20network%20nodes%20and%20connection%20lines%2C%20dark%20background%20with%20teal%20and%20warm%20amber%20highlights%2C%20digital%20art%20style%2C%20minimalist%20composition%2C%20soft%20gradients&width=1200&height=675&seq=article-1&orientation=landscape",
    featured: true,
    tags: ["人工智能", "数字化转型", "未来工作"],
    views: 12500,
    likes: 342,
  },
  {
    id: "2",
    title: "绿色经济浪潮：可持续发展如何改变商业版图",
    excerpt: "随着全球碳中和目标的推进，绿色经济正在成为新的商业增长引擎。从新能源到循环经济，企业正在重新定义价值创造的方式。",
    content: `绿色经济浪潮：可持续发展如何改变商业版图

随着全球碳中和目标的推进，绿色经济正在成为新的商业增长引擎。从新能源到循环经济，企业正在重新定义价值创造的方式。

政策驱动下的产业转型

各国政府相继出台碳中和政策，推动着整个产业链的绿色转型。在中国，\"双碳\"目标已经写入了国家发展战略，带动了数万亿规模的绿色投资。欧盟的绿色新政则通过碳边境调节机制，将环保要求扩展到了全球贸易体系。

新能源产业爆发式增长

光伏、风电、储能、氢能等新能源产业正在经历前所未有的增长。2025年全球可再生能源投资首次超过化石能源，这标志着能源转型的关键转折点。与此同时，新能源汽车的渗透率在许多市场已经超过50%。

循环经济模式兴起

\"取用-制造-丢弃\"的线性经济模式正在被循环经济取代。从时尚行业的服装回收计划到电子产品的模块化设计，企业正在探索如何将废弃物转化为资源。据估计，到2030年，循环经济将创造超过4.5万亿美元的商业价值。

ESG投资成为主流

环境、社会和治理（ESG）因素已经成为投资决策的核心考量。全球ESG资产管理规模已超过40万亿美元，占总投资资产的近三分之一。企业不再将ESG视为成本，而是看作是风险管理和价值创造的工具。

绿色技术创新加速

碳捕获、生物基材料、垂直农业等绿色技术正在从实验室走向商业化。这些创新不仅有助于解决环境问题，还创造了全新的市场和就业机会。绿色科技初创企业在2025年获得了创纪录的风投资金。

消费者偏好的转变

越来越多的消费者愿意为环保产品支付溢价。调查显示，超过70%的消费者表示环境影响会影响他们的购买决策。这种消费偏好的转变正在倒逼企业加快绿色转型。

绿色经济的浪潮才刚刚开始。对于企业来说，越早拥抱可持续发展，就越能在未来的竞争中占据有利位置。`,
    category: "business",
    categoryName: "商业",
    author: "李雨晴",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20an%20Asian%20female%20business%20analyst%20in%20her%20late-20s%2C%20wearing%20a%20white%20blouse%2C%20neutral%20studio%20background%2C%20soft%20lighting%2C%20warm%20smile%2C%20high%20quality%20portrait&width=200&height=200&seq=author-2&orientation=squarish",
    date: "2026-06-25",
    readTime: "6分钟",
    image: "https://readdy.ai/api/search-image?query=Modern%20sustainable%20green%20business%20concept%20with%20lush%20plants%20growing%20in%20a%20modern%20office%20space%2C%20natural%20light%20streaming%20through%20large%20windows%2C%20warm%20wooden%20textures%2C%20editorial%20photography%20style%2C%20clean%20minimalist%20composition&width=1200&height=675&seq=article-2&orientation=landscape",
    featured: true,
    tags: ["绿色经济", "可持续发展", "ESG"],
    views: 9800,
    likes: 256,
  },
  {
    id: "3",
    title: "慢生活运动：为什么越来越多的年轻人选择\"减速\"",
    excerpt: "在快节奏的都市生活中，一场\"慢生活\"运动正在年轻人中悄然兴起。从数字排毒到正念冥想，人们开始重新思考什么是真正的幸福。",
    content: `慢生活运动：为什么越来越多的年轻人选择\"减速\"

在快节奏的都市生活中，一场\"慢生活\"运动正在年轻人中悄然兴起。从数字排毒到正念冥想，人们开始重新思考什么是真正的幸福。

数字过载的时代

智能手机、社交媒体、即时通讯……我们生活在一个被信息包围的时代。调查显示，普通人每天查看手机的次数超过150次，平均每次只停留不到30秒。这种碎片化的注意力模式正在影响着我们的深度思考能力和心理健康。

\"慢\"的重新定义

慢生活并不意味着懒惰或低效。它强调的是有意识地选择如何度过时间，关注质量而非数量。 slow food（慢食）、slow travel（慢旅行）、slow fashion（慢时尚）——这些\"慢\"运动都在倡导一种更加 mindful 的生活方式。

数字排毒的兴起

越来越多的人开始定期进行\"数字排毒\"——有意识地减少使用电子设备的时间。从每周一天的\"无屏幕日\"到为期一个月的社交媒体戒断，各种形式的数字排毒正在帮助人们找回内心的平静。

正念与冥想大众化

正念冥想已经从佛教修行变成了主流的健康实践。Headspace、Calm等冥想应用的下载量以亿计，企业也开始为员工提供正念培训。科学研究证实，正念练习可以有效降低压力、改善睡眠、提升专注力。

极简主义生活方式

\"少即是多\"的哲学正在影响人们的生活方式。从断舍离到胶囊衣橱，从极简家居到精简社交，年轻人正在用减法来为生活创造空间。这种极简主义不仅是一种审美选择，更是一种对抗消费主义的生活态度。

社区与连接的回归

在虚拟连接泛滥的时代，人们开始渴望真实的面对面互动。社区花园、共享工作空间、兴趣社团等实体社交场景正在复兴。慢生活倡导者认为，高质量的线下连接是幸福感的重要来源。

慢生活不是逃避，而是一种更加 conscious 的生活方式选择。在这个永不停歇的世界里，学会减速或许是我们最需要掌握的技能。`,
    category: "lifestyle",
    categoryName: "生活",
    author: "王诗涵",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20an%20Asian%20female%20lifestyle%20writer%20in%20her%20early-30s%2C%20wearing%20a%20casual%20beige%20sweater%2C%20neutral%20studio%20background%2C%20soft%20natural%20lighting%2C%20thoughtful%20expression%2C%20high%20quality%20portrait&width=200&height=200&seq=author-3&orientation=squarish",
    date: "2026-06-22",
    readTime: "7分钟",
    image: "https://readdy.ai/api/search-image?query=Serene%20slow%20living%20scene%20with%20a%20cozy%20reading%20nook%20by%20a%20large%20window%2C%20warm%20afternoon%20light%2C%20a%20cup%20of%20tea%20and%20an%20open%20book%20on%20a%20wooden%20table%2C%20indoor%20plants%2C%20soft%20neutral%20tones%2C%20editorial%20lifestyle%20photography%2C%20peaceful%20atmosphere&width=1200&height=675&seq=article-3&orientation=landscape",
    featured: true,
    tags: ["慢生活", "心理健康", "极简主义"],
    views: 15600,
    likes: 478,
  },
  {
    id: "4",
    title: "当代艺术的边界：当科技遇见创造力",
    excerpt: "数字艺术、NFT、AI绘画……科技正在重新定义艺术的边界。这场技术与创造力的碰撞，既带来了前所未有的可能性，也引发了关于艺术本质的深刻讨论。",
    content: `当代艺术的边界：当科技遇见创造力

数字艺术、NFT、AI绘画……科技正在重新定义艺术的边界。这场技术与创造力的碰撞，既带来了前所未有的可能性，也引发了关于艺术本质的深刻讨论。

数字艺术的崛起

传统艺术界曾经对数字艺术持怀疑态度，但这种情况正在迅速改变。2025年，威尼斯双年展首次设立了专门的数字艺术展馆，标志着这一媒介获得了主流艺术界的认可。数字艺术家们利用编程、算法和交互技术，创造出传统媒介无法实现的作品。

AI艺术引发的争议

Midjourney、DALL-E等AI绘画工具的普及，让\"人人都是艺术家\"成为可能。但这也引发了激烈的争议：AI生成的作品能算作艺术吗？如果AI学习了人类艺术家的风格，这算不算抄袭？艺术品交易所和拍卖行正在制定新的规则来应对这一挑战。

NFT市场的成熟与反思

经历了2022年的狂热和2023年的冷静期后，NFT市场正在走向成熟。艺术界的NFT不再只是投机工具，而是成为了数字艺术确权和收藏的新方式。 museums 和 galleries 开始将NFT纳入永久收藏体系。

沉浸式艺术体验

TeamLab、Artechouse等沉浸式艺术空间在全球各大城市兴起，用投影、传感器和互动技术创造出身临其境的艺术体验。这些体验模糊了观众与作品之间的界限，让艺术从\"观看\"变成了\"参与\"。

虚拟现实中的艺术创作

VR绘画工具如Tilt Brush让艺术家可以在三维空间中自由创作。VR艺术展览也开始出现，观众可以戴上头显，在虚拟画廊中漫步。这种全新的创作和体验方式正在催生新的艺术语言。

科技与艺术的未来

无论技术如何发展，艺术的核心始终是人类情感和思想的表达。科技只是工具，它为艺术家提供了新的表达方式，但不能替代艺术家的创意和洞察力。未来的艺术世界将是人类创造力与技术的协作，而非替代。

艺术的边界正在被重新定义，但艺术的本质——触动人心、引发思考——永远不会改变。`,
    category: "culture",
    categoryName: "文化",
    author: "陈思远",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20an%20Asian%20male%20art%20critic%20in%20his%20mid-40s%2C%20wearing%20round%20glasses%20and%20a%20dark%20turtleneck%2C%20neutral%20studio%20background%2C%20soft%20lighting%2C%20intellectual%20expression%2C%20high%20quality%20portrait&width=200&height=200&seq=author-4&orientation=squarish",
    date: "2026-06-20",
    readTime: "9分钟",
    image: "https://readdy.ai/api/search-image?query=Abstract%20digital%20art%20installation%20with%20flowing%20colorful%20light%20projections%20in%20a%20dark%20gallery%20space%2C%20holographic%20effects%2C%20teal%20and%20warm%20orange%20tones%2C%20visitors%20silhouettes%20interacting%20with%20the%20art%2C%20immersive%20experience%2C%20editorial%20photography&width=1200&height=675&seq=article-4&orientation=landscape",
    featured: false,
    tags: ["当代艺术", "数字艺术", "AI绘画"],
    views: 8200,
    likes: 198,
  },
  {
    id: "5",
    title: "全球南方崛起：新兴市场如何重塑世界经济格局",
    excerpt: "金砖国家扩容、非洲自贸区启动、东南亚制造业转移——全球南方正在以新的姿态参与世界经济。这股变革力量将深刻影响未来数十年的国际格局。",
    content: `全球南方崛起：新兴市场如何重塑世界经济格局

金砖国家扩容、非洲自贸区启动、东南亚制造业转移——全球南方正在以新的姿态参与世界经济。这股变革力量将深刻影响未来数十年的国际格局。

金砖国家的新篇章

2025年金砖国家正式扩容至15个成员国，涵盖了全球45%的人口和35%的GDP。这一扩容不仅是数量的增加，更标志着新兴经济体在全球治理中话语权的提升。新开发银行的放贷规模已经超过了亚洲开发银行，成为发展中国家基础设施融资的重要来源。

非洲：下一个增长前沿

非洲大陆自由贸易区（AfCFTA）的全面实施，正在创造一个覆盖13亿人口、GDP超过3.5万亿美元的一体化市场。从尼日利亚的科技创业到肯尼亚的移动支付，从埃塞俄比亚的制造业到卢旺达的数字化治理，非洲正在展现出惊人的创新活力。

东南亚的制造升级

随着全球供应链的重新布局，东南亚正在成为\"中国+1\"战略的最大受益者。越南、印尼、泰国等国家不仅承接了制造业转移，还在积极向价值链上游攀升。越南的半导体产业、印尼的电动车电池、泰国的数字经济，都展现出强劲的增长势头。

去美元化的趋势

全球南方国家正在加速推进本币结算和支付系统多元化。人民币跨境支付系统（CIPS）的交易量在过去两年增长了300%，多个新兴市场国家开始使用数字货币进行跨境贸易结算。这种趋势虽然短期内不会动摇美元的主导地位，但正在改变国际货币体系的格局。

技术转移与自主创新

从5G到人工智能，从新能源到生物技术，全球南方正在从技术的接受者转变为创新的参与者。印度的数字支付体系、巴西的农业技术、中国的电动汽车……这些来自新兴市场的创新正在反向输出到发达国家。

气候正义与发展权

在全球气候谈判中，全球南方国家越来越强调\"共同但有区别的责任\"。发展中国家要求发达国家为历史排放承担责任，同时坚持自身的发展权。这一立场正在影响全球气候治理的走向。

全球南方的崛起不是对现有秩序的挑战，而是对更加包容和公平的全球经济体系的呼唤。`,
    category: "international",
    categoryName: "国际",
    author: "刘建国",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20an%20Asian%20male%20international%20correspondent%20in%20his%20early-50s%2C%20wearing%20a%20gray%20suit%20jacket%2C%20neutral%20studio%20background%2C%20professional%20lighting%2C%20serious%20yet%20approachable%20expression%2C%20high%20quality%20portrait&width=200&height=200&seq=author-5&orientation=squarish",
    date: "2026-06-18",
    readTime: "10分钟",
    image: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20a%20modern%20booming%20city%20in%20an%20emerging%20market%20country%2C%20skyscrapers%20and%20construction%20cranes%2C%20golden%20hour%20lighting%2C%20warm%20tones%2C%20editorial%20photography%20style%2C%20dynamic%20urban%20landscape%20showing%20growth%20and%20development&width=1200&height=675&seq=article-5&orientation=landscape",
    featured: false,
    tags: ["新兴市场", "全球经济", "金砖国家"],
    views: 11200,
    likes: 315,
  },
  {
    id: "6",
    title: "量子计算商业化元年：从实验室到市场的跨越",
    excerpt: "2026年被业界称为量子计算商业化元年。IBM、Google、以及中国科大的研究团队相继宣布了重大 breakthrough，量子计算机距离解决实际问题越来越近。",
    content: `量子计算商业化元年：从实验室到市场的跨越

2026年被业界称为量子计算商业化元年。IBM、Google、以及中国科大的研究团队相继宣布了重大 breakthrough，量子计算机距离解决实际问题越来越近。

技术里程碑

今年早些时候，IBM发布了超过1000量子比特的处理器，并展示了在药物分子模拟中的应用。Google的量子AI团队则在纠错码方面取得了突破性进展，将量子比特的相干时间提升了十倍。中国科学技术大学的研究团队成功实现了量子通信网络的城市级部署。

应用场景落地

量子计算最先商业化的领域包括：金融风险管理、药物研发、材料科学和供应链优化。摩根大通已经开始使用量子算法优化投资组合，辉瑞利用量子模拟加速新药发现。这些早期应用虽然规模有限，但展示了量子计算的实用潜力。

中国量子科技的进展

中国在量子通信和量子计算领域处于世界领先水平。\"墨子号\"量子卫星实现了洲际量子通信，\"祖冲之号\"量子计算原型机在特定问题上展示了量子优势。国家对量子科技的投入持续增加，多个省市设立了量子科技产业园区。

产业生态的形成

从硬件制造商到软件开发者，从云服务提供商到咨询公司，量子计算的产业生态正在快速形成。亚马逊、微软等科技巨头纷纷推出量子云服务，让中小企业也能接触到量子计算能力。

挑战与瓶颈

尽管进展迅速，量子计算仍面临诸多挑战。量子纠错、量子比特稳定性、低温运行环境等技术难题尚未完全解决。业界普遍认为，真正具有广泛商业价值的\"容错量子计算机\"还需要5-10年的研发。

人才争夺战

量子科技人才的短缺已经成为全球性问题。各国高校纷纷开设量子信息专业，科技企业以高薪争夺顶尖研究人员。中国也在加大量子科技人才培养力度，多所高校建立了量子信息研究院。

量子计算的商业化进程已经开始，虽然我们仍处于早期阶段，但变革的 momentum 已经不可逆转。`,
    category: "technology",
    categoryName: "科技",
    author: "张明远",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20an%20Asian%20male%20journalist%20in%20his%20mid-30s%2C%20wearing%20a%20dark%20blazer%2C%20neutral%20studio%20background%2C%20soft%20natural%20lighting%2C%20confident%20expression%2C%20high%20quality%20portrait&width=200&height=200&seq=author-1&orientation=squarish",
    date: "2026-06-15",
    readTime: "8分钟",
    image: "https://readdy.ai/api/search-image?query=Futuristic%20quantum%20computer%20laboratory%20with%20glowing%20cryogenic%20equipment%2C%20blue%20and%20purple%20holographic%20data%20visualizations%2C%20clean%20white%20lab%20environment%2C%20scientists%20in%20white%20coats%20working%2C%20high-tech%20atmosphere%2C%20editorial%20photography&width=1200&height=675&seq=article-6&orientation=landscape",
    featured: false,
    tags: ["量子计算", "前沿科技", "商业化"],
    views: 18900,
    likes: 523,
  },
  {
    id: "7",
    title: "新消费品牌的崛起密码：从0到10亿的增长逻辑",
    excerpt: "完美日记、元气森林、三顿半……这些新消费品牌用短短几年时间完成了传统品牌几十年的增长。它们的成功背后，是一套全新的品牌营销和用户运营方法论。",
    content: `新消费品牌的崛起密码：从0到10亿的增长逻辑

完美日记、元气森林、三顿半……这些新消费品牌用短短几年时间完成了传统品牌几十年的增长。它们的成功背后，是一套全新的品牌营销和用户运营方法论。

DTC模式的威力

Direct-to-Consumer（直接面向消费者）模式是新消费品牌的核心策略。通过绕过传统分销渠道，品牌可以直接与消费者建立联系，获取第一方数据，快速响应市场变化。这种模式不仅降低了渠道成本，还加速了产品迭代速度。

社交媒体的杠杆效应

新消费品牌深谙社交媒体的传播规律。从种草笔记到直播带货，从KOL合作到UGC激励，它们将社交媒体变成了品牌增长的主要引擎。一个精心策划的内容营销活动，可以在几天内创造数亿级别的曝光。

产品即内容

新消费品牌将产品设计本身变成了传播内容。三顿半的精品速溶咖啡以\"小杯子\"造型成为社交平台上的拍照道具，元气森林的日系包装设计引发了模仿热潮。这种\"产品即内容\"的策略，让每一款产品都自带传播属性。

用户共创的新模式

从产品研发到品牌传播，新消费品牌让用户深度参与品牌建设。花西子的\"用户共创\"计划征集了数万条产品改进建议，半亩花田的\"粉丝体验官\"机制让消费者成为品牌代言人。

供应链的数字化升级

新消费品牌利用数字化工具重构供应链。C2M（消费者到制造）模式让生产更加精准，柔性供应链让小批量、多品类的生产成为可能。这种敏捷的供应链能力，是传统品牌难以复制的竞争优势。

资本的双刃剑

新消费品牌的快速发展离不开资本的推动，但过度依赖融资也带来了风险。2023-2024年的新消费\"退潮\"让许多品牌意识到，仅有流量和营销是不够的，产品力和品牌力才是长期竞争力。

新消费品牌的崛起不是偶然，而是数字化转型、消费升级和社交媒体革命共同作用的结果。`,
    category: "business",
    categoryName: "商业",
    author: "李雨晴",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20an%20Asian%20female%20business%20analyst%20in%20her%20late-20s%2C%20wearing%20a%20white%20blouse%2C%20neutral%20studio%20background%2C%20soft%20lighting%2C%20warm%20smile%2C%20high%20quality%20portrait&width=200&height=200&seq=author-2&orientation=squarish",
    date: "2026-06-12",
    readTime: "7分钟",
    image: "https://readdy.ai/api/search-image?query=Modern%20branding%20and%20product%20design%20flatlay%20with%20minimalist%20packaging%2C%20pastel%20color%20products%20arranged%20on%20a%20clean%20white%20surface%2C%20social%20media%20aesthetic%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20warm%20tones&width=1200&height=675&seq=article-7&orientation=landscape",
    featured: false,
    tags: ["新消费", "品牌营销", "DTC"],
    views: 7400,
    likes: 189,
  },
  {
    id: "8",
    title: "城市漫游者：探索亚洲最值得一去的隐秘街巷",
    excerpt: "避开游客扎堆的打卡点，深入本地人的生活空间。从曼谷的老社区到东京的下町，从首尔的韩屋村到新加坡的小印度，发现城市最动人的一面。",
    content: `城市漫游者：探索亚洲最值得一去的隐秘街巷

避开游客扎堆的打卡点，深入本地人的生活空间。从曼谷的老社区到东京的下町，从首尔的韩屋村到新加坡的小印度，发现城市最动人的一面。

曼谷： Bangrak 的艺术与烟火

在游客蜂拥至大皇宫和考山路时，Bangrak 区却保持着悠闲的本地节奏。这个曾经的葡萄牙和华人移民社区，如今是曼谷最有趣的创意聚集地。从街头壁画到独立咖啡馆，从传统中式寺庙到当代艺术画廊，Bangrak 是新旧交融的缩影。

东京：谷根千的怀旧时光

谷中、根津、千駄木这三个下町地区合称\"谷根千\"，是东京最具怀旧气息的区域。这里没有高楼大厦，只有低矮的木质民居、古老的杂货店和悠闲的街道。春天赏樱，秋天观枫，四季都有不同的韵味。

首尔：西村的韩屋新生

在景福宫西侧的西村，传统韩屋正在经历一场优雅的复兴。这些百年老宅被改造成精品民宿、独立书店和手工艺工坊。漫步在西村的小巷中，你可以感受到传统与现代如何和谐共存。

新加坡：小印度的色彩盛宴

小印度不仅是新加坡印度族群的聚居区，更是一个充满活力的文化熔炉。从清晨的香料市场到夜晚的排灯节庆典，从传统的南印度寺庙到现代的涂鸦艺术，小印度用色彩和香气讲述着多元文化的故事。

香港：深水埗的本土匠心

深水埗是香港最后的\"平民天堂\"。这里没有奢侈品店，有的是几十年历史的老字号、手工修鞋铺、传统点心店和电子零件市场。在深水埗，你可以看到香港最 authentic 的一面。

城市漫游的意义

真正的旅行不是打卡清单，而是与城市建立 connection。当我们放慢脚步，走进那些游客罕至的街巷，才能真正理解一座城市的灵魂。`,
    category: "lifestyle",
    categoryName: "生活",
    author: "王诗涵",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20an%20Asian%20female%20lifestyle%20writer%20in%20her%20early-30s%2C%20wearing%20a%20casual%20beige%20sweater%2C%20neutral%20studio%20background%2C%20soft%20natural%20lighting%2C%20thoughtful%20expression%2C%20high%20quality%20portrait&width=200&height=200&seq=author-3&orientation=squarish",
    date: "2026-06-10",
    readTime: "6分钟",
    image: "https://readdy.ai/api/search-image?query=Narrow%20colorful%20Asian%20street%20scene%20with%20traditional%20shophouses%2C%20hanging%20lanterns%2C%20vibrant%20street%20life%2C%20warm%20golden%20hour%20lighting%2C%20editorial%20travel%20photography%2C%20rich%20cultural%20atmosphere%2C%20deep%20shadows%20and%20warm%20tones&width=1200&height=675&seq=article-8&orientation=landscape",
    featured: false,
    tags: ["旅行", "城市探索", "亚洲"],
    views: 13400,
    likes: 412,
  },
  {
    id: "9",
    title: "后疫情时代的全球电影产业：流媒体与院线的博弈",
    excerpt: "电影院回来了，但流媒体已经改变了游戏规则。从好莱坞到宝莱坞，从韩国到日本，全球电影产业正在经历一场深刻的结构性变革。",
    content: `后疫情时代的全球电影产业：流媒体与院线的博弈

电影院回来了，但流媒体已经改变了游戏规则。从好莱坞到宝莱坞，从韩国到日本，全球电影产业正在经历一场深刻的结构性变革。

院线的复兴与挑战

2025年全球影院票房终于恢复到了疫情前的水平，但这并不意味着一切如初。观众的观影习惯已经改变：窗口期缩短、同步上映成为常态、高端体验（IMAX、杜比影院）成为吸引观众的关键。

流媒体的持续扩张

Netflix、Disney+、Amazon Prime Video等平台的全球订阅用户总数已经超过15亿。这些平台不仅改变了发行模式，更改变了内容创作本身。\" binge-worthy \"的剧集化叙事、数据驱动的内容决策、全球化的制作合作，都是流媒体时代的新特征。

好莱坞的全球化策略

面对本土市场的饱和，好莱坞正在加速全球化布局。从中国元素的加入到韩国团队的深度合作，从印度市场的定制化内容到非洲故事的国际化表达，好莱坞正在用更加多元的内容吸引全球观众。

亚洲电影的崛起

韩国电影在奥斯卡的持续成功、《鱿鱼游戏》的全球现象、日本动画的文化输出、印度宝莱坞的数字化转型——亚洲电影正在从边缘走向中心。这些成功不仅提升了亚洲文化的全球影响力，也改变了全球内容市场的格局。

独立电影的新生存之道

独立电影制作者正在探索新的生存策略。从众筹融资到NFT发行，从电影节巡展到流媒体独家，独立电影人正在用创新的方式绕过传统发行体系，直接与观众建立联系。

技术驱动的观影体验

从8K分辨率到沉浸式音频，从VR电影到互动叙事，技术正在创造全新的观影体验。这些新技术虽然尚未成为主流，但代表了电影产业的未来方向。

电影产业的未来将是院线体验与流媒体的共存，全球内容与本土文化的融合，技术创新与艺术表达的平衡。`,
    category: "culture",
    categoryName: "文化",
    author: "陈思远",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20an%20Asian%20male%20art%20critic%20in%20his%20mid-40s%2C%20wearing%20round%20glasses%20and%20a%20dark%20turtleneck%2C%20neutral%20studio%20background%2C%20soft%20lighting%2C%20intellectual%20expression%2C%20high%20quality%20portrait&width=200&height=200&seq=author-4&orientation=squarish",
    date: "2026-06-08",
    readTime: "8分钟",
    image: "https://readdy.ai/api/search-image?query=Classic%20movie%20theater%20interior%20with%20red%20velvet%20seats%20and%20golden%20accents%2C%20projector%20light%20beam%20cutting%20through%20the%20darkness%2C%20atmospheric%20and%20nostalgic%2C%20cinematic%20photography%2C%20warm%20amber%20tones%2C%20editorial%20style&width=1200&height=675&seq=article-9&orientation=landscape",
    featured: false,
    tags: ["电影", "流媒体", "娱乐产业"],
    views: 9200,
    likes: 267,
  },
  {
    id: "10",
    title: "气候变化下的粮食安全：创新农业技术的突破",
    excerpt: "极端天气频发、耕地资源减少、人口持续增长——全球粮食安全面临前所未有的挑战。精准农业、垂直农场、基因编辑作物等创新技术正在带来希望。",
    content: `气候变化下的粮食安全：创新农业技术的突破

极端天气频发、耕地资源减少、人口持续增长——全球粮食安全面临前所未有的挑战。精准农业、垂直农场、基因编辑作物等创新技术正在带来希望。

气候变化的农业冲击

过去五年，全球主要粮食产区经历了前所未有的极端天气。从北美的干旱到南亚的洪水，从欧洲的酷热到非洲的蝗灾，气候变化正在直接影响全球的粮食供给。联合国粮农组织警告，到2030年，气候变化可能导致全球粮食产量下降15-20%。

精准农业的普及

利用物联网、卫星遥感和人工智能，精准农业正在改变传统的耕作方式。从土壤传感器到无人机巡田，从变量施肥到智能灌溉，这些技术让农民能够以更少的资源获得更高的产出。在美国，采用精准农业技术的农场平均增产15%，节水30%。

垂直农场的商业化

在城市中心建造\"植物工厂\"的愿景正在成为现实。AeroFarms、Plenty等垂直农场公司已经在纽约、旧金山等城市建立了商业化运营的垂直农场。这些设施使用LED光照和水培技术，可以在任何气候条件下全年生产蔬菜，用水量仅为传统农业的5%。

基因编辑作物的突破

CRISPR基因编辑技术正在创造出更具抗逆性的作物品种。抗旱玉米、耐盐水稻、抗病小麦……这些新品种有望在气候变化背景下保障粮食产量。与传统转基因技术不同，基因编辑的精确性让监管和消费者接受度都更高。

再生农业的兴起

再生农业强调恢复土壤健康、增加生物多样性和封存碳排放。从免耕种植到覆盖作物，从轮牧系统到农林复合，这些实践不仅提高了土地的长期生产力，还有助于缓解气候变化。

农业科技的投资热潮

农业科技（AgTech）已成为风险投资的热门赛道。2025年全球AgTech投资超过200亿美元，从农业机器人到区块链溯源，从气候保险到农产品电商，各种创新正在重塑农业价值链。

创新技术是应对粮食安全挑战的重要工具，但技术本身不能解决所有问题。公平的贸易体系、可持续的消费模式、对农民的支持政策，都是保障全球粮食安全不可或缺的组成部分。`,
    category: "international",
    categoryName: "国际",
    author: "刘建国",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20an%20Asian%20male%20international%20correspondent%20in%20his%20early-50s%2C%20wearing%20a%20gray%20suit%20jacket%2C%20neutral%20studio%20background%2C%20professional%20lighting%2C%20serious%20yet%20approachable%20expression%2C%20high%20quality%20portrait&width=200&height=200&seq=author-5&orientation=squarish",
    date: "2026-06-05",
    readTime: "9分钟",
    image: "https://readdy.ai/api/search-image?query=Modern%20vertical%20farm%20interior%20with%20rows%20of%20green%20leafy%20vegetables%20under%20purple%20LED%20grow%20lights%2C%20high-tech%20agricultural%20facility%2C%20clean%20white%20walls%2C%20futuristic%20food%20production%2C%20editorial%20photography%2C%20cool%20and%20warm%20tones%20mix&width=1200&height=675&seq=article-10&orientation=landscape",
    featured: false,
    tags: ["粮食安全", "农业科技", "气候变化"],
    views: 10500,
    likes: 298,
  },
];

export const editorPicks = [
  {
    id: "ep-1",
    quote: "在信息爆炸的时代，深度思考比快速消费更有价值。",
    author: "周雅琴",
    title: "首席内容官",
    verified: true,
    avatar: "https://readdy.ai/api/search-image?query=Black%20and%20white%20editorial%20portrait%20of%20an%20Asian%20female%20executive%20in%20her%2040s%2C%20side%20profile%20with%20head%20slightly%20tilted%20up%2C%20professional%20elegant%20attire%2C%20high%20contrast%20studio%20lighting%2C%20white%20background%2C%20authoritative%20yet%20warm%20expression%2C%20shoulder-up%20framing&width=400&height=500&seq=editor-1&orientation=portrait",
  },
];

export const platformStats = [
  { label: "文章总数", value: "2,500+" },
  { label: "签约作者", value: "180+" },
  { label: "月活读者", value: "500万+" },
  { label: "覆盖国家", value: "35+" },
];